export default __webpack_public_path__ + "static/media/button-Rotate-Off.34d33030.png";